import { h, Fragment } from 'preact'
import Downshift from 'downshift'
import matchSorter from 'match-sorter'

function filterItems(items, filter, keys) {
  return filter
    ? matchSorter(items, filter, {
        keys
      })
    : items
}

export default function Autocomplete({
  items,
  renderItemLabel = item => item.value,
  filterKeys = ['value'],
  getItemKey,
  label,
  style,
  icon,
  name,
  append,
  ...props
}) {
  return (
    <Downshift itemToString={item => (item ? item.value : '')} {...props}>
      {({
        getInputProps,
        getItemProps,
        getLabelProps,
        getMenuProps,
        isOpen,
        inputValue,
        highlightedIndex,
        selectedItem,
        openMenu
      }) => {
        const filteredItems = filterItems(items, inputValue, filterKeys)

        return (
          <div
            class="relative border border-grey-light invalid:border-red-50 focus-within:line-bottom mt-3"
            style={style}
          >
            {icon}
            <label class="sr-only" {...getLabelProps()}>
              {label}
            </label>
            <input
              data-no-focus-visible=""
              type="text"
              class="appearance-none block rounded-none w-full bg-white border-0 text-current py-0 pl-11 pr-4 xs:pr-6 -xs:text-sm outline-none relative z-10 placeholder:text-black"
              style="height:65px"
              autocomplete="off"
              placeholder={label}
              name={name}
              {...getInputProps({
                onFocus: () => {
                  if (
                    typeof selectedItem === 'undefined' ||
                    selectedItem === null
                  ) {
                    openMenu()
                  }
                }
              })}
            ></input>
            <div
              {...getMenuProps({
                style: { marginTop: -1, paddingTop: 67 },
                className:
                  'absolute pin-l pin-r pin-t -mx-px bg-white shadow max-h-1/2-screen overflow-auto' +
                  (isOpen ? '' : ' hidden')
              })}
            >
              <ul class="list-reset w-full table pb-5 pt-4">
                {isOpen ? (
                  <Fragment>
                    {filteredItems.map((item, index) => (
                      <li
                        {...getItemProps({
                          key: getItemKey(item),
                          index,
                          item,
                          className:
                            'instant-search-result relative flex sm:table-row text-grey-dark selected:text-black transition-color no-underline sm:border-b border-transparent cursor-pointer before:none',
                          style: {
                            // backgroundColor:
                            //   highlightedIndex === index ? 'lightgray' : null,
                            color: selectedItem === item ? 'black' : undefined
                          }
                        })}
                      >
                        {renderItemLabel(item, inputValue)}
                      </li>
                    ))}
                    {append
                      ? append.map((item, index) => (
                          <li
                            {...getItemProps({
                              key: `appended-${index}`,
                              index: filteredItems.length + index,
                              item,
                              className:
                                'instant-search-result relative flex sm:table-row text-grey-dark selected:text-black transition-color no-underline sm:border-b border-transparent cursor-pointer before:none',
                              style: {
                                // backgroundColor:
                                //   highlightedIndex === index ? 'lightgray' : null,
                                color:
                                  selectedItem === item ? 'black' : undefined
                              }
                            })}
                          >
                            <div class="flex-auto sm:w-auto sm:table-cell pt-4 pb-4 pl-6 sm:pl-8 md:pl-10 pr-8">
                              {item.label}
                            </div>
                            <div class="flex-auto sm:w-auto sm:table-cell pt-4 pb-4 pr-6 sm:pr-8 md:pr-10 text-right"></div>
                          </li>
                        ))
                      : null}
                  </Fragment>
                ) : null}
              </ul>
            </div>
          </div>
        )
      }}
    </Downshift>
  )
}



// WEBPACK FOOTER //
// ./src/js/widget/Autocomplete.js